// Sunny Day design tokens — see design_handoff_redesign/README.md for the
// full spec. Imported by the new sticker primitives and any component that
// needs the warm/sticker palette directly.
//
// Critical visual rule: every interactive surface has a 2.5px ink outline
// AND a hard-offset shadow (no soft drop-shadows). That's the entire
// aesthetic — sticker/patch outlines on warm cream.

export const SUNNY = {
  // Colors
  cream:   "#F8E9C9",  // app + sheet background — warmed up from spec's #FBF3E2
  paper:   "#fffaec",  // card / surface background
  sun:     "#F9B33C",  // primary accent — sun, hero highlights
  sunDeep: "#E88A1A",  // sun gradient end / sunset
  tomato:  "#E8542E",  // secondary accent — distance, "let's go", error
  grass:   "#3E9B5F",  // tertiary — features, parks
  sky:     "#5FB0D6",  // tertiary — fog, ocean, info
  ink:     "#2B1E15",  // ALL text, outlines, shadows
  inkSoft: "#5a4634",  // body copy on cream

  // Fonts (Google Fonts loaded in public/index.html)
  fontDisplay: '"Fraunces", "Recoleta", Georgia, serif',
  fontBody: '"Nunito", "Quicksand", system-ui, sans-serif',

  // Shapes
  radiusCard: 20,
  radiusButton: 14,
  radiusPill: 999,
  borderWidth: 2.5,
  shadowCard: "4px 4px 0 #2B1E15",
  shadowButton: "3px 3px 0 #2B1E15",
  // Use this on dark CTAs (ink-filled buttons) for the off-color punch
  shadowButtonAccent: "3px 3px 0 #F9B33C",
  shadowSticker: "2px 2px 0 #2B1E15",
};
